import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-partner-api',
  templateUrl: './partner-api.component.html',
  styleUrls: ['./partner-api.component.scss']
})
export class PartnerApiComponent {
  contactMail = environment.adminMail;
}
